<template>
  <div>
    <van-notice-bar
      left-icon="volume-o"
      text="根据《快递暂行条例》，快递寄件需要实名认证"
    />
    <van-form
      class="cerForm"
      autocomplete="off"
      ref="realForm"
      @submit="onSubmit"
      validate-first
    >
      <van-field
        v-model="realName"
        name="realName"
        label="姓名"
        required
        placeholder="请输入真实姓名"
        :rules="[{ required: true }]"
      />

      <van-field
        v-model="idCardNo"
        type="idcard"
        name="idCard"
        label="身份证"
        required
        maxlength="18"
        placeholder="请输入身份证号"
        clearable
        clear-trigger="always"
        :rules="
          idCardNo
            ? [
                {
                  pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                  message: '请输入正确的身份证'
                }
              ]
            : [
                {
                  pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
                }
              ]
        "
      />
      <!-- touchstart.native.stop -->
      <!-- 弹出身份证键盘 -->
      <!-- <van-number-keyboard
        :show="idCardShow"
        extra-key="X"
        close-button-text="完成"
        v-model="idCardNo"
        maxlength="18"
        @blur="keyboardBlur()"
      /> -->
      <van-field
        v-model="phone"
        type="number"
        name="phone"
        label="手机号"
        maxlength="11"
        required
        placeholder="请输入手机号"
        :rules="
          phone
            ? [
                {
                  pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                  message: '请输入正确的手机号'
                }
              ]
            : [
                {
                  pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/
                }
              ]
        "
        confirm-type="完成"
      />
      <div class="footerSubmit flex" v-show="!focus">
        <van-button color="#ff7b00" class="submitBtn" native-type="submit"
          >信息正确，提交</van-button
        >
      </div>
    </van-form>
    <div class="flex whiteBg uploadImg">
      <!--身份证上传-->
      <div id="uploaderID">
        <div class="uploaderBox">
          <van-uploader
            v-model="idImg"
            multiple
            :max-count="1"
            :before-read="beforeRead"
            :after-read="compressImg"
            @delete="deleteAxiosimg"
            upload-text="身份证正面"
          />
        </div>
        <div class="uploaderBox">
          <van-uploader
            v-model="idImgReserve"
            :before-read="beforeRead"
            :after-read="compressImg"
            multiple
            :max-count="1"
            @delete="deleteAxiosimg"
            upload-text="身份证反面"
          />
        </div>
      </div>
      <!--身份证上传-->
    </div>
    <loading ref="loading" />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      realName: '',
      idCardNo: '',
      phone: '',
      idCardShow: false,
      idImg: [],
      idImgReserve: [],
      imgUrlList: [],
      defaultPhoneHeight: 0,
      nowPhoneHeight: 0,
      focus: false,
      upload: false
    }
  },
  watch: {
    nowPhoneHeight: function() {
      if (this.defaultPhoneHeight !== this.nowPhoneHeight) {
        // 手机键盘被唤起了。
        this.focus = true
      } else {
        // 手机键盘被关闭了。
        this.focus = false
      }
    }
  },
  mounted() {
    this.defaultPhoneHeight = window.innerHeight
    window.onresize = () => {
      this.nowPhoneHeight = window.innerHeight
    }
  },
  methods: {
    // idCardClick() {
    //   this.idCardShow = true
    //   document.activeElement.blur()
    // },
    keyboardBlur() {
      this.idCardShow = false
      this.$refs.realForm.validate('idCard')
    },
    getUUID(n = 32) {
      var str = 'abcdefghijklmnopqrstuvwxyz0123456789' // 可以作为常量放到random外面
      var result = ''
      for (var i = 0; i < n; i++) {
        result += str[parseInt(Math.random() * str.length)]
      }
      return result
    },
    uploadImg(front, back) {
      this.FrontUrl(front, back)
    },
    deleteAxiosimg() {
      this.upload = false
    },
    beforeRead(file) {
      if (file.type !== 'image/jpeg') {
        this.$toast.fail('请上传 jpg 格式图片')
        return false
      }
      return true
    },
    compressImg(file) {
      // 大于2MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 2000000) {
        const width = 1200
        const height = 900
        // 创建Canvas对象(画布)
        let canvas = document.createElement('canvas')
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext('2d')
        // 创建新的图片对象
        let img = new Image()
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          let comHeight = img.height // 图片的高
          let comWidth = img.width // 图片的宽
          if (img.width > width) {
            // 如果图片高大于 定义的压缩后的宽，则使用压缩后的宽代替图片的宽
            comWidth = width
          }
          if (img.height > height) {
            comHeight = height
          }
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = comWidth
          canvas.height = comHeight
          // drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
          // 如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/
          // context.clearRect(0, 0, comWidth, comHeight) // 清除画布
          context.drawImage(img, 0, 0, comWidth, comHeight)

          let baseImg = canvas.toDataURL('image/jpeg')
          const blobBin = atob(baseImg.split(',')[1])
          let data = []
          for (let i = 0; i < blobBin.length; i++) {
            data.push(blobBin.charCodeAt(i))
          }
          file.file = new Blob([new Uint8Array(data)], { type: 'image/png' }) // 压缩后的图片文件
        }
      }
    },
    onSubmit() {
      if (this.idImgReserve.length === 0 || this.idImg.length === 0) {
        this.$notify('请上传身份证照片')
        return
      }
      if (this.upload) {
        this.upDate()
      } else {
        this.FrontUrl(this.idImg, this.idImgReserve)
        // console.log(this.idImg, this.idImgReserve)
      }
      // console.log(this.idImg, this.idImgReserve)
    },
    upDate() {
      let params = {
        addressId: this.$route.query.addressId,
        realName: this.realName,
        phone: this.phone,
        idCardNo: this.idCardNo,
        idCardFrontUrl: this.idImg[0].url,
        idCardBackUrl: this.idImgReserve[0].url
      }
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .realName(data)
        .then(res => {
          if (res.code === 0) {
            this.$refs.loading.close()
            this.idImg = []
            this.idImgReserve = []
            let obj = this.$store.state.senderInfo
            obj.realnameFlag = 1
            this.$store.commit('set_senderInfo', obj)
            this.$notify({
              message: res.msg,
              type: 'success',
              duration: 600,
              onClose: () => {
                this.$router.go(-1)
                // window.history.go(-1)
              }
            })
          } else {
            this.$refs.loading.close()
            this.$notify({
              message: res.msg ? res.msg : '上传失败，请重试',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$refs.loading.close()
          console.log(err)
          this.$notify({
            message: err.msg ? err.msg : '请求失败'
          })
        })
    },
    FrontUrl(front, back) {
      // 上传身份证正面
      let token = ''
      let domainUrl = ''
      let key = this.getUUID()
      this.$refs.loading.show('上传中')
      this.$api
        .getQiniuToken()
        .then(res => {
          token = res.token
          domainUrl = res.domainUrl
          let formData = new FormData()
          formData.append('token', token)
          formData.append('key', key)
          formData.append('file', front[0].file)
          const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 30 * 1000
          }
          axios
            .post('https://up.qiniup.com', formData, config)
            .then(res => {
              // console.log(res.data)
              front[0].url = domainUrl + '/' + res.data.key
              this.backImg(back)
            })
            .catch(err => {
              this.$refs.loading.close()
              if (err.message.includes('timeout')) {
                this.$dialog.alert({
                  title: '提示',
                  message: '当前网络不佳，请重新刷新一下哦~'
                })
              } else {
                this.$notify({
                  message: err.msg ? err.msg : '上传失败，请重试',
                  type: 'danger'
                })
              }
            })
        })
        .catch(err => {
          this.$refs.loading.close()
          this.$notify({
            message: err.msg ? err.msg : '上传失败，请重试',
            type: 'danger'
          })
        })
    },
    backImg(back) {
      // 上传身份证反面
      let token = ''
      let domainUrl = ''
      let key = this.getUUID()
      this.$refs.loading.show('上传中')
      this.$api
        .getQiniuToken()
        .then(res => {
          token = res.token
          domainUrl = res.domainUrl
          let formData = new FormData()
          formData.append('token', token)
          formData.append('key', key)
          formData.append('file', back[0].file)
          const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 30 * 1000
          }
          axios
            .post('https://up.qiniup.com', formData, config)
            .then(res => {
              // console.log(res.data)
              this.upload = true
              back[0].url = domainUrl + '/' + res.data.key
              this.upDate()
            })
            .catch(err => {
              this.$refs.loading.close()
              if (err.message.includes('timeout')) {
                this.$dialog.alert({
                  title: '提示',
                  message: '当前网络不佳，请重新刷新一下哦~'
                })
              } else {
                this.$notify({
                  message: err.msg ? err.msg : '上传失败，请重试',
                  type: 'danger'
                })
              }
            })
        })
        .catch(err => {
          this.$refs.loading.close()
          this.$notify({
            message: err.msg ? err.msg : '上传失败，请重试',
            type: 'danger'
          })
        })
    }
  }
}
</script>
<style lang="scss">
.cerForm {
  margin: 15px 0;
}
.uploadImg {
  width: 100%;
  //   height: 180px;
  #uploaderID {
    // display: flex;
    width: 100vw;
    // justify-content: center;
    // align-items: center;
    margin: 10px;
    .uploaderBox {
      float: left !important;
      width: 50%;
    }
    .van-uploader__preview {
      width: 100% !important;
      height: 33vw !important;

      .van-image {
        width: 100% !important;
        height: 33vw !important;
      }
    }
    .van-uploader__upload {
      width: 100% !important;
      height: 33vw !important;
      margin: 0 10px !important;
    }
    .van-uploader {
      width: 100%;
    }
    .van-uploader__input {
      height: 100%;
      width: 100%;
    }
  }
}
.footerSubmit {
  position: fixed;
  bottom: 20px;
  width: 80%;
  height: 40px;
  margin-left: 50%;
  transform: translateX(-50%);
}
.submitBtn {
  color: #fff;
  font-size: 14px !important;
  width: 100%;
  height: 100% !important;
}
.van-notice-bar,
.van-notify--danger,
.van-notify-success {
  height: 40px !important;
}
.van-notice-bar__content,
.van-cell,
.van-notify--danger,
.van-uploader__upload-icon,
.van-uploader__upload-text,
.van-cell--required::before {
  font-size: 14px !important;
}
</style>
<style lang="scss" scoped>
.van-icon {
  font-size: 14px !important;
}
</style>
